import React from 'react';
import styled from 'styled-components';
import { colors } from '../constants';

const CheckLabel = styled.div`
  display: flex;
  align-items: center;
  &:before {
    content: '✓';
    color: transparent;
    height: 20px;
    width: 20px;
    flex-shrink: 0;
    margin-right: 8px;
    border: 2px solid black;
    border-radius: 4px;
    display: block;
    line-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
  }
`;

const Check = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 1px;
  width: 0;
  &:disabled + label {
    color: #888;
  }
  &:focus ~ ${CheckLabel}:before {
    border-color: ${colors.secondary};
    background-color: ${colors.secondaryBackground};
  }
  &:checked ~ ${CheckLabel}:before {
    background: ${colors.primary};
    color: white;
  }
`;

function CheckBox({ name, checked, onChange, children }) {
  return (
    <label>
      <Check
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange || null}
      />
      <CheckLabel>{children}</CheckLabel>
    </label>
  );
}

export default CheckBox;
